import { DRAFT_CLOSE_ACTION } from '../Draft.constants'

export const DRAFT_CLOSE_ACTION_SELECT_MODAL_FIELD_ACTION = 'action'

export const DRAFT_CLOSE_ACTION_SELECT_MODAL_INITIAL_VALUES = {
  [DRAFT_CLOSE_ACTION_SELECT_MODAL_FIELD_ACTION]: DRAFT_CLOSE_ACTION.saveDraft,
}
